import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faCheck,
  faLightbulb,
  faBuildingColumns,
  faPhone,
  faComments,
  faClipboardCheck,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import service1 from "../assets/img/meeting2.jpg";
import service2 from "../assets/img/meeting3.jpg";
import service3 from "../assets/img/meeting4.jpg";
import service4 from "../assets/img/meeting5.jpg";
import { Breadcrumb } from "../components/Breadcrumb";

const Service = () => {
  const services = [
    {
      id: 1,
      title: "Wealth & Goal Planning",
      subtitle: "Your Goals. Our Roadmap.",
      image: service1,
      content: (
        <>
          <p>
            Life is full of meaningful milestones — buying a home, sending your
            child to college, or retiring comfortably. These goals require more
            than just saving — they require strategic planning.
          </p>
          <p>
            At <strong>SAG Financials</strong>, we take the time to understand
            what matters most to you and build a customized roadmap to get you
            there.
          </p>
          <p>We help you plan for:</p>
          <ul>
            <li>Retirement — so you can maintain your lifestyle, even after you stop working.</li>
            <li>Child’s Education — ensuring your child’s dreams are fully funded.</li>
            <li>Marriage Planning — planning ahead for a stress-free celebration.</li>
            <li>Short-Term Goals — vacations, vehicles, or home upgrades without affecting long-term security.</li>
          </ul>
          <p>
            We use a combination of goal-based planning tools, real-time
            projections, and financial modelling to help you stay on track.
          </p>
        </>
      ),
    },
    {
      id: 2,
      title: "Investment Solutions",
      subtitle: "Make Your Money Work Smarter",
      image: service2,
      content: (
        <>
          <p>
            Growing your wealth requires more than luck — it requires informed
            decisions, strategic allocations, and consistent tracking.
          </p>
          <p>
            Our investment approach is built on understanding your{" "}
            <strong>risk profile, time horizon,</strong> and{" "}
            <strong>financial goals</strong>, then designing a portfolio that
            reflects your unique needs.
          </p>
          <p>Our offerings include:</p>
          <ul>
            <li>SIPs (Systematic Investment Plans)</li>
            <li>Mutual Funds — equity, debt, and hybrid options</li>
            <li>Bonds & Debentures — for low-risk, steady returns</li>
            <li>Corporate Fixed Deposits — with higher-than-bank FD rates</li>
          </ul>
          <p>
            We don’t just recommend investments — we explain them. Our digital
            tools make tracking and managing your portfolio simple, transparent,
            and accessible.
          </p>
        </>
      ),
    },
    {
      id: 3,
      title: "Protection Planning",
      subtitle: "Because Life is Unpredictable",
      image: service3,
      content: (
        <>
          <p>
            Life is full of uncertainties — and that’s why protection planning
            is essential. Whether it’s safeguarding your family’s future or
            covering unexpected medical expenses, we ensure you’re financially
            protected.
          </p>
          <p>Our protection solutions include:</p>
          <ul>
            <li>Term Life Insurance — protect your family’s future affordably.</li>
            <li>Health Insurance & Mediclaim — quality healthcare shouldn’t drain savings.</li>
            <li>Personal Accident Insurance — cover disability, loss of income, and accidents.</li>
          </ul>
          <p>
            We assess your lifestyle, responsibilities, and liabilities to
            suggest the right coverage — not too much, not too little.
            We also help you compare, choose, and claim — because peace of mind
            should come without paperwork stress.
          </p>
        </>
      ),
    },
    {
      id: 4,
      title: "Tax Planning & Loan Advisory",
      subtitle: "Save Smarter. Borrow Better.",
      image: service4,
      content: (
        <>
          <p>
            Taxes and loans are often misunderstood — but when managed properly,
            they can work to your advantage. We provide expert advice on both.
          </p>
          <h6>
            <FontAwesomeIcon icon={faLightbulb} className="text-primary me-2" />
            Tax Planning:
          </h6>
          <ul>
            <li>Reduce tax outgo with legitimate government-backed strategies.</li>
            <li>Identify instruments under Section 80C, 80D, and more.</li>
            <li>Align tax planning with long-term investment goals.</li>
            <li>Optimize savings based on income, expenses, and family structure.</li>
          </ul>
          <h6>
            <FontAwesomeIcon icon={faBuildingColumns} className="text-primary me-2" />
            Loan Advisory:
          </h6>
          <ul>
            <li>Compare loan offers across banks and NBFCs.</li>
            <li>Assess EMI affordability without compromising future goals.</li>
            <li>Get advice on balance transfers, top-ups, and rate negotiations.</li>
          </ul>
          <p>The result? You borrow smart, save more, and manage debt confidently.</p>
        </>
      ),
    },
  ];

  return (
    <>

      <Breadcrumb currentName={"Service"} currentParentName={"Our Service"} />

      {/* Service Tabs */}
      <div className="container-xxl service py-5">
        <div className="container">
          <div className="text-center mx-auto" style={{ maxWidth: "700px" }}>
            <p className="d-inline-block border rounded  fw-semi-bold py-1 px-3" style={{
              color: "var(--primary)",
              borderColor: "var(--primary)",
              backgroundColor: "var(--white)",
            }}>
              Our Services
            </p>
            <h1 className="display-5 mb-4" style={{ color: "var(--heading)", fontWeight: "700" }}>
              Personalized Financial Solutions for Every Stage of Life
            </h1>
            <p className="text-muted">
              There’s no one-size-fits-all financial advice. Every person, every
              family, and every business has a unique journey — and we’re here
              to guide you through yours with clarity, confidence, and care.
            </p>
          </div>

          <div className="row g-4 mt-4">
            {/* Nav */}
            <div className="col-lg-4">
              <div className="nav nav-pills flex-column me-4">
                {services.map((srv, i) => (
                  <button
                    key={srv.id}
                    className={`nav-link w-100 d-flex align-items-center text-start border p-4 mb-4 ${i === 0 ? "active" : ""
                      }`}
                    data-bs-toggle="pill"
                    data-bs-target={`#tab-pane-${srv.id}`}
                  >
                    <h5 className="m-0" style={{
                      color: "var(--primary)",

                    }}>
                      <FontAwesomeIcon
                        icon={faBars}
                        className=" me-3"


                      />
                      {srv.title}
                    </h5>
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="col-lg-8">
              <div className="tab-content">
                {services.map((srv, i) => (
                  <div
                    key={srv.id}
                    className={`tab-pane fade ${i === 0 ? "show active" : ""}`}
                    id={`tab-pane-${srv.id}`}
                  >
                    <div className="row g-4">
                      <div className="col-md-6" style={{ minHeight: "350px" }}>
                        <motion.div
                          initial={{ opacity: 0, scale: 0.9 }}
                          whileInView={{ opacity: 1, scale: 1 }}
                          transition={{ duration: 0.6 }}
                          className="position-relative h-100"
                        >
                          <img
                            className="position-absolute rounded w-100 h-100 shadow-lg"
                            src={srv.image}
                            // style={{ objectFit: "cover" }}
                            alt={srv.title}
                          />
                        </motion.div>
                      </div>
                      <div className="col-md-6">
                        <motion.div
                          initial={{ opacity: 0, y: 30 }}
                          whileInView={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.6 }}
                        >
                          <h3 className="mb-3">{srv.subtitle}</h3>
                          <div className="text-muted">{srv.content}</div>
                        </motion.div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Why Clients Choose SAG Financials ===== */}
      <section
        className="container py-5"
        style={{ backgroundColor: "var(--light-bg)" }}
      >
        <div className="text-center mb-5">
          <motion.h2
            className="fw-bold mb-3"
            style={{ color: "var(--heading)" }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Why Clients Choose SAG Financials
          </motion.h2>

          <motion.p
            className="mx-auto"
            style={{
              color: "var(--text)",
              maxWidth: "700px",
              fontSize: "1.1rem",
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            We’re proud to be a boutique financial advisory firm — small in size,
            big on impact. Here’s what makes us different:
          </motion.p>
        </div>

        <div className="row g-4">
          {[
            "Truly Personalized Planning – strategies built around your life, not templates.",
            "Certified & Ethical – AMFI, IRDA, and NISM certified with top ethical standards.",
            "Digital Convenience, Human Touch – manage finances digitally with personal support.",
            "22+ Years of Experience – over two decades of financial expertise.",
            "Award-Winning Performance – MDRT-level achievements and client satisfaction.",
          ].map((point, idx) => (
            <motion.div
              key={idx}
              className="col-md-6 col-lg-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.15, duration: 0.6 }}
            >
              <div
                className="p-4 border rounded shadow-sm h-100"
                style={{
                  backgroundColor: "var(--white)",
                  borderColor: "var(--secondary)",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 18px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <FontAwesomeIcon
                  icon={faCheck}
                  style={{
                    color: "var(--primary)",
                    marginRight: "10px",
                    fontSize: "1.3rem",
                  }}
                />
                <span style={{ color: "var(--text)", fontWeight: 500 }}>
                  {point}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* ===== Who We Work With ===== */}
      <section
        className="container-fluid py-5"
        style={{
          background: "linear-gradient(90deg, var(--primary), var(--accent))",
          color: "var(--white)",
        }}
      >
        <div className="container text-center">
          <motion.h2
            className="fw-bold mb-3"
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Who We Work With
          </motion.h2>

          <motion.p
            className="mb-4"
            style={{ opacity: 0.9, fontSize: "1.1rem" }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Our services are designed to support individuals and businesses
            across all life stages.
          </motion.p>

          <ul
            className="list-unstyled text-center mx-auto"
            style={{
              fontSize: "1.1rem",
              maxWidth: "700px",
              lineHeight: "1.8",
            }}
          >
            {[
              "• Young professionals starting to build wealth",
              "• Mid-career families balancing multiple goals",
              "• Pre-retirees & retirees seeking financial security",
              "• Entrepreneurs & self-employed professionals",
              "• Women clients seeking independence and protection",
            ].map((item, i) => (
              <motion.li
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1 }}
              >
                {item}
              </motion.li>
            ))}
          </ul>

          <motion.p
            className="mt-3"
            style={{ opacity: 0.9 }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            No matter where you are financially — just starting or seasoned —
            we tailor our services to your goals.
          </motion.p>
        </div>
      </section>

      {/* ===== How to Get Started ===== */}
      <section
        id="get-started"
        className="container py-5 text-center"
        style={{ backgroundColor: "var(--light-bg)" }}
      >
        <motion.h2
          className="fw-bold mb-4"
          style={{ color: "var(--heading)" }}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          How to Get Started
        </motion.h2>

        <motion.p
          className="mb-4 mx-auto"
          style={{
            color: "var(--text)",
            maxWidth: "750px",
            fontSize: "1.1rem",
          }}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
        >
          Financial planning doesn’t have to be complicated. With SAG
          Financials, you’ll always have a clear path forward and a partner who
          listens.
        </motion.p>

        <div className="d-flex flex-wrap justify-content-center gap-4 fs-5">
          {[
            {
              icon: faPhone,
              text: "Book a free, no-obligation consultation",
              link: "tel:+917011468336", // change number
            },
            {
              icon: faComments,
              text: "Talk to us via WhatsApp or email",
              link: "https://wa.me/917011468336", // change WhatsApp number
            },
            // {
            //   icon: faClipboardCheck,
            //   text: "Get a personalized financial roadmap",
            //   link: "/financial-roadmap",
            // },
            {
              icon: faStar,
              text: "Start building your future — with expert support",
              link: "/contact",
            },
          ].map((item, i) => (
            <motion.a
              key={i}
              href={item.link}
              className="px-4 py-3 border rounded shadow-sm bg-white text-decoration-none"
              style={{
                minWidth: "300px",
                color: "var(--text)",
                borderColor: "var(--secondary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.15 }}
              whileHover={{
                scale: 1.05,
                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
              }}
            >
              <FontAwesomeIcon
                icon={item.icon}
                style={{
                  color: "var(--primary)",
                  marginRight: "10px",
                }}
              />
              {item.text}
            </motion.a>
          ))}
        </div>
      </section>

    </>
  );
};

export default Service;
